// extracted by mini-css-extract-plugin
export default {"overlay":"hz-z","bodyOpen":"iz-z","content":"jz-z","header":"kz-z","close":"lz-z","closeNoHeading":"mz-z"};